"use client";

import { useEffect, useState } from "react";
import useApi from "@/components/api/useApi";

// system layer types MapBoxMap knows how to render
export const SYSTEM_LAYER_TYPES = ["BOUNDARY", "BUILDING_FOOTPRINTS"];

// Loads a profile's public system layers (e.g. the community boundary) for MapBoxMap's systemLayers prop.
// token is an optional embed API key; returns [{ type, geojson }] for the layers that exist.
export default function useSystemLayers(name, types, token) {
  const api = useApi();
  const [systemLayers, setSystemLayers] = useState([]);

  const typeKey = (types ?? [])
    .map(t => String(t).toUpperCase())
    .filter(t => SYSTEM_LAYER_TYPES.includes(t))
    .join(",");

  useEffect(() => {
    if (!name || !typeKey) {
      setSystemLayers([]);
      return;
    }
    let cancelled = false;
    Promise.all(
      typeKey.split(",").map(type =>
        api
          .getPublicSystemLayerGeoJson(name, type, token)
          .then(geojson => ({ type, geojson }))
          .catch(() => ({ type, geojson: null }))
      )
    ).then(results => {
      if (!cancelled) {
        setSystemLayers(results.filter(r => r.geojson?.features?.length));
      }
    });
    return () => {
      cancelled = true;
    };
  }, [name, typeKey, token]);

  return systemLayers;
}
